import React from 'react';
import { Link } from 'react-router-dom';

interface BackButtonProps {
  href?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ href = '/' }) => {
  return (
    <Link 
      to={href}
      className="flex items-center gap-2 py-3 px-1 text-gray-700 hover:text-gray-500 transition-colors no-underline"
    >
      
      <div><span className="text-lg">←</span>&nbsp;Back</div>
    </Link>
  );
};

export default BackButton;